import IconFont from '@/common/Icon';
import { courseRecord, gradeRecord, schoolAreaRecord } from '@/utils/const';
import { Divider, Dropdown, Menu } from 'antd';
import { useEffect, useState } from 'react';
import style from '../Analysis.module.less';
import { CourseConfig } from '../AnalysisPortal';

interface SearchProps {
  gradeDcode: string;
  courseConfig: CourseConfig[];
  onCourseChange?: (courseName: string) => void;
  onSchoolAreaChange?: (s: string) => void;
}

const Search: React.FC<SearchProps> = props => {

  const [currentCourse, setCurrentCourse] = useState('');
  const [currentArea] = useState('');
  // const [currentArea, setCurrentArea] = useState('');

  const courseChange = (course: string) => {
    if (course === currentCourse) return false;
    setCurrentCourse(course);
    props.onCourseChange && props.onCourseChange(course);
  };

  // const schoolAreaChange = (area: string) => {
  //   if (area === currentArea) return false;
  //   setCurrentArea(area);
  //   props.onSchoolAreaChange && props.onSchoolAreaChange(area);
  // };

  const initCourseList = () => {
    // 主要目的是为了将全科拿到最前面
    const list = props.courseConfig.map(i => ({
      label: courseRecord[i.name] || '全科',
      value: i.name
    }));
    const allCourseIndex = list.findIndex(i => i.value === 'WHOLE_COURSE_T');
    if (allCourseIndex > 0) {
      const allCourse = list.splice(allCourseIndex, 1)[0];
      list.unshift(allCourse);
    }
    return list;
  };

  const coureOptions = initCourseList();

  useEffect(() => {
    // 默认选中第一个科目
    const firstCourse = coureOptions[0]?.value;
    if (firstCourse) {
      setCurrentCourse(coureOptions[0]?.value);
      props.onCourseChange && props.onCourseChange(firstCourse);
    }
  }, [props.courseConfig]);

  const schoolAreaOption = [
    {
      label: '全市',
      value: ''
    },
    ...Object.entries(schoolAreaRecord).map(([key, value]) => ({
      label: value,
      value: key
    }))
  ];

  const courseMenu = <Menu items={
    coureOptions.map(i => {
      return {
        key: i.value,
        onClick: () => courseChange(i.value),
        label: <div className={i.value === currentCourse ? 'main' : ''}>{i.label}</div>
      };
    })
  }/>;

  // const schoolAreaMenu = <Menu items={
  //   schoolAreaOption.map(i => {
  //     return {
  //       key: i.value,
  //       label: <span className={i.value === currentArea ? 'main' : ''} onClick={() => schoolAreaChange(i.value)}>{i.label}</span>
  //     };
  //   })
  // }/>;

  return (
    <div className={style.search}>
      <div className={style.dropdown}>
        {/* <Dropdown arrow overlay={schoolAreaMenu} placement="bottom">
          <span>
            {schoolAreaOption.find(i => i.value === currentArea)?.label}
            <IconFont type="icon-zhankai" />
          </span>
        </Dropdown> */}
        <span>
          {schoolAreaOption.find(i => i.value === currentArea)?.label}
        </span>
      </div>
      <Divider type="vertical" />
      <div>{gradeRecord[props.gradeDcode]}</div>
      <Divider type="vertical" />
      <div className={style.dropdown}>
        <Dropdown arrow overlay={courseMenu} placement="bottom">
          <span>
            {coureOptions.find(i => i.value === currentCourse)?.label}
            <IconFont type="icon-zhankai" />
          </span>
        </Dropdown>
      </div>
    </div>
  );
};

export default Search;